import styled from "styled-components";
import { Box, Text, Form } from "dash-ui";

export const Container = styled(Box)`
  padding: ${({ theme }) => theme.space * 6}px;
`;

export const TitleText = styled(Text)`
  font-weight: bold;
`;

export const DescriptionText = styled(Text)`
  color: ${({ theme }) => theme.colors.n70};
`;

export const SectionTitle = styled(Text)`
  font-weight: bold;
  display: block;
`;

export const TransitionsContainer = styled(Box)<{ disabled: boolean }>`
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  margin-top: ${({ theme }) => theme.space * 4}px;
`;

export const FormFieldLabel = styled(Form.Label)`
  font-size: 14px;
  font-weight: 600;
`;

export const HelpText = styled(Text)`
  color: ${({ theme }) => theme.colors.n70};
  font-size: 0.85rem;
`;

export const StyledInput = styled(Form.Input)`
  width: ${({ theme }) => theme.space * 50}px;
`;

export const FieldContainer = styled(Box)`
  margin-top: ${({ theme }) => theme.space * 4}px;
`;